import { render, staticRenderFns } from "./SchoolEnrollmentReports.vue?vue&type=template&id=2b2ff102&"
import script from "./SchoolEnrollmentReports.vue?vue&type=script&lang=js&"
export * from "./SchoolEnrollmentReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports